module.exports = __webpack_public_path__ + "img/motorbikeFrontLeftOutline.eb29d73e.svg";